import { useState, useEffect } from 'react';
import { DatePicker, Select } from 'antd';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { GetDoctorsList } from '../../store/Actions/DoctorAction';

const { RangePicker } = DatePicker;
const { Option } = Select;

const FilterControls = ({ onFilterChange, isDoctor }) => {
  const dispatch = useDispatch();
  const { doctorsList } = useSelector(state => state.doctor);
  const [searchParams, setSearchParams] = useSearchParams();

  const [dateRange, setDateRange] = useState([
    searchParams.get('orderStartDate') ? dayjs(searchParams.get('orderStartDate'), 'YYYY-MM-DD') : dayjs(),
    searchParams.get('orderEndDate') ? dayjs(searchParams.get('orderEndDate'), 'YYYY-MM-DD') : dayjs()
  ]);
  const [selectedDoctor, setSelectedDoctor] = useState(searchParams.get('doctorId') || 'all');
  const [status, setStatus] = useState(searchParams.get('status') || 'all');
  const [searchText, setSearchText] = useState(searchParams.get('search') || '');

  // Fetch doctors list on component mount
  useEffect(() => {
    dispatch(GetDoctorsList());
  }, [dispatch]);

  // Helper function to update URL parameters
  const updateURLParams = (newParams) => {
    const params = new URLSearchParams(searchParams);

    Object.entries(newParams).forEach(([key, value]) => {
      if (value && value !== 'all') {
        params.set(key, value);
      } else {
        params.delete(key);
      }
    });

    setSearchParams(params);
  };

  const handleDateChange = dates => {
    setDateRange(dates);
    const filterData = {
      orderStartDate: dates?.[0]?.format('YYYY-MM-DD'),
      orderEndDate: dates?.[1]?.format('YYYY-MM-DD'),
      doctorId: selectedDoctor,
      status: status,
      search: searchText,
    };
    onFilterChange(filterData);
    updateURLParams({
      orderStartDate: filterData.orderStartDate,
      orderEndDate: filterData.orderEndDate,
    });
  };

  const handleDoctorChange = value => {
    setSelectedDoctor(value);
    const filterData = {
      orderStartDate: dateRange?.[0]?.format('YYYY-MM-DD'),
      orderEndDate: dateRange?.[1]?.format('YYYY-MM-DD'),
      doctorId: value,
      status: status,
      search: searchText,
    };
    onFilterChange(filterData);
    updateURLParams({ doctorId: value });
  };

  const handleStatusChange = value => {
    setStatus(value);
    const filterData = {
      orderStartDate: dateRange?.[0]?.format('YYYY-MM-DD'),
      orderEndDate: dateRange?.[1]?.format('YYYY-MM-DD'),
      doctorId: selectedDoctor,
      status: value,
      search: searchText,
    };
    onFilterChange(filterData);
    updateURLParams({ status: value });
  };

  const handleSearchChange = e => {
    setSearchText(e.target.value);
    const filterData = {
      orderStartDate: dateRange?.[0]?.format('YYYY-MM-DD'),
      orderEndDate: dateRange?.[1]?.format('YYYY-MM-DD'),
      doctorId: selectedDoctor,
      status: status,
      search: e.target.value,
    };
    onFilterChange(filterData);
    updateURLParams({ search: e.target.value });
  };

  return (
    <div className="card mb-4">
      <div className="card-body">
        <div className="row g-3 align-items-end">
          <div className="col-12 col-md-3 col-lg-3">
            <label className="form-label fw-bold mb-2">Date From:</label>
            <RangePicker
              format="YYYY-MM-DD"
              value={dateRange}
              onChange={handleDateChange}
              className="w-100"
              placeholder={['yyyy-mm-dd', 'yyyy-mm-dd']}
              showTime={false}
              style={{ width: '100%' }}
            />
          </div>
          {!isDoctor && <div className="col-6 col-md-2 col-lg-2">
            <label className="form-label fw-bold mb-2">Doctor:</label>
            <Select
              value={selectedDoctor}
              onChange={handleDoctorChange}
              className="w-100"
              placeholder="Select Doctor"
            >
              <Option value="all">All Doctors</Option>
              {doctorsList.map(doctor => (
                <Option key={doctor._id} value={doctor._id}>
                  {doctor.name}
                </Option>
              ))}
            </Select>
          </div>}
          {/* <div className="col-6 col-md-2 col-lg-2">
            <label className="form-label fw-bold mb-2">Status:</label>
            <Select
              value={status}
              onChange={handleStatusChange}
              className="w-100"
              placeholder="Select Status"
            >
              <Option value="all">All Status</Option>
              <Option value="upcoming">Upcoming</Option>
              <Option value="confirmed">Confirmed</Option>
              <Option value="completed">Completed</Option>
              <Option value="cancelled">Cancelled</Option>
            </Select>
          </div>
          <div className="col-12 col-md-5 col-lg-5">
            <label className="form-label fw-bold mb-2">Search:</label>
            <Input
              placeholder="Patient name…"
              prefix={<Search />}
              value={searchText}
              onChange={handleSearchChange}
              allowClear
              className="w-100"
              style={{ width: '100%' }}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default FilterControls;
